var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_a98ee93c22c69c866ff1129b48755c0cdd17226846bd8250eaa7ce81df03e982",
    x1: 58,
    y1: 108.1,
    x2: 142,
    y2: 108.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_a98ee93c22c69c866ff1129b48755c0cdd17226846bd8250eaa7ce81df03e982",
    x1: 84.7,
    y1: 104.9,
    x2: 115.3,
    y2: 104.9,
    xlinkHref: "#SVGID_0_a98ee93c22c69c866ff1129b48755c0cdd17226846bd8250eaa7ce81df03e982"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_a98ee93c22c69c866ff1129b48755c0cdd17226846bd8250eaa7ce81df03e982",
    x1: 67.5,
    y1: 88.4,
    x2: 87.7,
    y2: 88.4,
    xlinkHref: "#SVGID_0_a98ee93c22c69c866ff1129b48755c0cdd17226846bd8250eaa7ce81df03e982"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M100.1 80l-.2.2h0c-9.3-9.3-24.4-12.2-33.7-2.9-9.3 9.3-9.3 24.4 0 33.7l33.7 33.7 33.7-33.7h0l.2-.2c9.3-9.3 9.3-24.4 0-33.7-9.3-9.3-24.4-6.4-33.7 2.9z",
    stroke: "url(#SVGID_0_a98ee93c22c69c866ff1129b48755c0cdd17226846bd8250eaa7ce81df03e982)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M112.7 141.5h38.4V66.4l-17.4-11.9L113.8 41 100 31.6 86.2 41 66.3 54.5 48.9 66.4v75.1h38.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M159.3 57.1V72l-8.2-5.6-17.4-11.9L113.8 41 100 31.6 86.2 41 66.3 54.5 48.9 66.4 40.7 72V57.1L64.3 41 100 16.7 135.7 41l23.6 16.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M121.8 31.6V18.5h13.6v22.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_1_a98ee93c22c69c866ff1129b48755c0cdd17226846bd8250eaa7ce81df03e982)",
    d: "M114 99.4h-8.5v-8.5h-11v8.5H86v11h8.5v8.5h11v-8.5h8.5v-11z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M86.5 80.7s-15.1.2-17.7 15.3",
    stroke: "url(#SVGID_2_a98ee93c22c69c866ff1129b48755c0cdd17226846bd8250eaa7ce81df03e982)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialEvents);
export default __webpack_public_path__ + "static/media/socialEvents.553d01bcdb0fcf0a8d6a116656e53f0d.svg";
export { ForwardRef as ReactComponent };